// EN
export const propCreateHc = {
  firstCreate: {
    // Accommodation types
    typeApartmentLabel: `Apartment`,
    typeApartmentDesc: `Eine möblierte, in sich abgeschlossene Wohnung, die komplett vermietet wird.`,
    typeVillaLabel: `Villa oder Haus`,
    typeVillaDesc: `Häuser, Villen und Chalets, die komplett vermietet werden.`,
    typeHotelLabel: `Hotel, Hostel oder B&B`,
    typeHotelDesc: `Unterkünfte, die mehrere Zimmer verwalten.`,
    typeCampingLabel: `Campingplatz`,
    typeCampingDesc: `Campingplätze und Areale mit mehreren Stellplätzen oder Einheiten.`,

    // Venue / unit nouns
    venueHotel: `Hotel`,
    venueCamping: `Campingplatz`,
    roomHotel: `Zimmer`,
    roomCamping: `Stellplatz`,
    roomHotelPlural: `Zimmer`,
    roomCampingPlural: `Stellplätze`,
    yourVenue: `Ihr {venue}`,

    // Common buttons
    back: `Zurück`,
    continue: `Weiter`,

    // Step: type
    typeTitle: `Veröffentlichen wir Ihre Unterkunft!`,
    typeSubtitle: `Wählen Sie zunächst die Art der Unterkunft, die Sie veröffentlichen möchten.`,

    // Step: quantity
    quantityTitle: `Wie viele Unterkünfte möchten Sie veröffentlichen?`,
    quantitySubtitle: `Sie können mit einer beginnen oder gleich mehrere anlegen.`,
    oneTitle: `1 Unterkunft`,
    oneDesc: `Ich möchte vorerst nur eine veröffentlichen.`,
    manyTitle: `Mehr als 1 Unterkunft`,
    manyDesc: `Ich habe mehrere zu veröffentlichen.`,

    // Step: location (same building or not)
    locationTitle: `Befinden sie sich im selben Gebäude oder an derselben Adresse?`,
    locationSubtitle: `So können wir Ihre Unterkünfte optimal organisieren.`,
    sameBuildingYesTitle: `Ja, im selben Gebäude oder an derselben Adresse`,
    sameBuildingYesDesc: `Sie werden in einem einzigen Inserat mit mehreren Einheiten zusammengefasst.`,
    sameBuildingNoTitle: `Nein, an verschiedenen Adressen`,
    sameBuildingNoDesc: `Jede wird ein eigenständiges Inserat (das Sie danach einrichten).`,

    // Step: names (dynamic titles and subtitles)
    namesTitleAttach: `Fügen Sie Ihrem Inserat eine Einheit hinzu`,
    namesTitleHotel: `Wie heißt Ihr {venue}?`,
    namesTitleGrouped: `Benennen Sie jede Einheit`,
    namesTitleList: `Benennen Sie jede Unterkunft`,
    namesTitleDefault: `Wie heißt Ihre Unterkunft?`,
    namesSubAttach: `Sie wird als neue Einheit in „{name}“ hinzugefügt.`,
    yourListing: `Ihr Inserat`,
    namesSubHotel: `Diesen Namen sehen Ihre Gäste. Im nächsten Schritt fügen Sie die {room}typen hinzu.`,
    namesSubGrouped: `Jede Einheit hat ihren eigenen Kalender innerhalb desselben Inserats.`,
    namesSubList: `Jede wird ein eigenständiges Inserat mit eigenen Einstellungen.`,
    namesSubDefault: `Diesen Namen sehen Ihre Gäste. Sie können ihn jederzeit ändern.`,
    addUnitLabel: `Weitere Einheit hinzufügen`,
    addListingLabel: `Weitere Unterkunft hinzufügen`,

    // Main listing card (grouped)
    mainListingEyebrow: `Hauptinserat`,
    mainListingSub: `Fasst alle Einheiten dieses Gebäudes in einem einzigen Inserat zusammen.`,
    mainListingNameLabel: `Name der Hauptunterkunft`,
    mainListingNamePlaceholder: `Z. B. Residencial Bilbao`,
    mainListingNameHint: `Gebäude, Turm oder Standort, der die Einheiten zusammenfasst.`,
    currency: `Währung`,
    currencyHintUnit: `Übernachtungspreis für jede Einheit.`,

    // Unit cards
    unitNameLabel: `Name der Einheit`,
    listingNameLabel: `Name der Unterkunft`,
    phRoomCamping: `Z. B. Campingplatz Pinar del Mar`,
    phRoomHotel: `Z. B. Hotel Costa Azul`,
    phAttach: `Z. B. Luxus-Studio an der Playa Roca, direkt am Meer`,
    phGrouped: `Z. B. Apartment {n}A`,
    phList: `Unterkunft {n}`,
    phDefault: `Z. B. Apartment im Zentrum`,
    remove: `Entfernen`,
    internalNameOptional: `Interner Name (optional)`,
    pricePerNight: `Preis / Nacht`,
    currencyHintHotel: `Alle {rooms} verwenden diese Währung.`,

    // Internal name (single-name case)
    internalNameLabel: `Interner Name`,
    optional: `(optional)`,
    internalNamePlaceholderSingle: `Z. B. Apartment renoviert 2024 / Schlüssel beim Concierge`,
    internalNameHint: `Nur Sie sehen ihn, zur internen Zuordnung. Gästen wird er nicht angezeigt.`,

    // Step: room types (hotel/campsite)
    roomsTitle: `Welche {rooms} hat {venue}?`,
    roomsSubtitle: `Fügen Sie jeden {room}typ mit Anzahl und Preis pro Nacht hinzu. Sie können das jederzeit ändern.`,
    roomTypeLabel: `{room}typ`,
    phRoomTypeCamping: `Z. B. Stellplatz mit Stromanschluss`,
    phRoomTypeHotel: `Z. B. Deluxe-Doppelzimmer`,
    quantity: `Anzahl`,
    addRoomType: `{room}typ hinzufügen`,

    // Step: address
    addressTitle: `Wo befindet sich Ihre Unterkunft?`,
    addressSubtitle: `Beginnen Sie zu tippen und wählen Sie die Adresse. Wir nutzen sie für die Karte und den Check-in.`,
    country: `Land`,
    countryHint: `Wir suchen Adressen nur innerhalb dieses Landes.`,
    address: `Adresse`,
    addressPlaceholder: `Straße, Nummer, Stadt…`,
    addressPlaceholderNoCountry: `Wählen Sie zuerst das Land`,
    city: `Stadt`,
    zipCode: `Postleitzahl`,

    // Step: rate
    priceTitle: `Ihr Standardpreis pro Nacht`,
    priceSubtitle: `Das ist Ihr Grundpreis. Sie können ihn danach nach Saison oder Kanal anpassen.`,
    priceLabel: `Preis pro Nacht`,
    perNight: `/ Nacht`,
    priceHint: `Sie können ihn jederzeit im Panel ändern.`,

    // Primary button and creation reason
    createUnit: `Einheit hinzufügen`,
    createVenue: `{venue} erstellen`,
    createListingsPlural: `Meine Unterkunft erstellen | Meine {count} Unterkünfte erstellen`,
    reasonUnit: `Einheit`,
    reasonListing: `Inserat`,

    // Toasts / validation
    toastCompleteToContinue: `Füllen Sie die Angaben aus, um fortzufahren.`,
    toastCompleteNames: `Geben Sie den Namen jeder Unterkunft an.`,
    toastCompleteLocation: `Geben Sie den Standort an.`,
    toastCompleteRooms: `Vervollständigen Sie jedes Zimmer: Name, Anzahl und Preis pro Nacht.`,
    toastRoomRatePerUnit: `Geben Sie den Übernachtungspreis für jede Einheit an.`,
    toastCompleteRate: `Geben Sie den Übernachtungspreis an.`,
    toastCreatedPlural: `Unterkunft erstellt! | Unterkünfte erstellt!`,
    toastCreateError: `Wir konnten die Unterkunft nicht erstellen. Bitte versuchen Sie es erneut.`,
  },

  welcome: {
    // Header titles
    arrivalTitleCaps: `Anreisehinweise`,
    arrivalTitle: `Anreisehinweise`,
    arrivalSubtitle: `Nachricht, die der Gast am Tag seiner Anreise erhält.`,
    welcomeTitle: `Willkommensnachricht`,
    welcomeSubtitle: `Nachricht, die der Gast nach Abschluss des Check-ins erhält.`,
    loadingMessages: `Nachrichten werden geladen...`,

    // Room-level welcome
    roomWelcomeTitle: `Willkommensnachricht für dieses Zimmer`,
    roomWelcomeSub: `Wenn Sie das Feld leer lassen, wird die allgemeine Willkommensnachricht des Hotels gesendet. Schalter, Anhänge und OTA werden auf Hotelebene konfiguriert.`,

    // Welcome switch
    welcomeEnableTitle: `Willkommensnachricht senden`,
    welcomeEnableSub: `Der Gast erhält sie nach Abschluss des Check-ins. Wenn Sie die Option ausschalten, wird sie nicht gesendet.`,

    // Clone
    clone: `Klonen`,
    clonePullTitle: `Einstellungen von einer anderen Unterkunft übernehmen`,
    clonePullSub: `Die Willkommensnachricht einer anderen hierher importieren`,
    clonePushTitle: `Diese Konfiguration auf eine andere Unterkunft kopieren`,
    clonePushSub: `Diese Willkommensnachricht auf andere anwenden`,
    cloneModalPullTitle: `Willkommenseinstellungen übernehmen`,
    cloneModalPushTitle: `Willkommensnachricht kopieren`,
    cloneModalPullSubtitle: `Wählen Sie die Unterkunft, von der Sie die Einstellungen übernehmen möchten. Sie werden auf dieses Inserat angewendet.`,
    cloneModalPushSubtitle: `Kopieren Sie diese Konfiguration (Texte, Modus, OTA und Anhänge) auf die von Ihnen gewählten Unterkünfte.`,
    itemNounWelcome: `die Willkommensnachricht`,
    arrivalTitleNoun: `Anreisehinweise`,
    itemNounArrival: `die Anreisehinweise`,

    // Configuration mode
    modeConfigLabel: `Konfigurationsmodus`,
    modeSingleTitle: `Eine einzige Nachricht`,
    modeSingleDesc: `Alle Einheiten teilen sich dieselbe Nachricht`,
    modeActive: `Aktiv`,
    modePropertyTitle: `Pro Unterkunft`,
    modePropertyDesc: `Jede Einheit hat ihre eigene Nachricht`,
    modePropertyNotice: `Einzelmodus aktiv. Bearbeiten Sie die Nachricht in der jeweiligen Unterkunft.`,

    // Arrival switch
    arrivalEnableTitle: `Anreisehinweise senden`,
    arrivalAutoSend: `Sie werden am Anreisetag{atTime} automatisch gesendet.`,
    arrivalAtTime: ` um {time}`,

    // Channels / sending
    deliveryChannels: `Versandkanäle`,
    channelEmail: `E-Mail`,
    sendAlsoOta: `Auch über OTA senden`,
    sendTime: `Sendezeit`,

    // Editor
    editorSubtitle: `Richten Sie sie je Sprache ein. Tipp: Nutzen Sie Emojis und kurze Texte.`,
    translateTitle: `Von {lang} in die anderen Sprachen übersetzen`,
    translatingLangLabel: `{lang} wird übersetzt…`,
    translatingGeneric: `Wird übersetzt…`,
    translate: `Übersetzen`,

    // Attachments
    uploading: `Wird hochgeladen…`,
    attach: `Anhängen`,
    emojis: `Emojis`,
    variables: `Variablen`,
    variablesHint: `Zum Einfügen anklicken. Beim Senden werden sie durch die echten Buchungsdaten ersetzt.`,
    uploadDone: `Gesendet. Wird auf dem Server gespeichert…`,
    uploadSizeProgress: `{done} von {total} MB`,
    attachHint: `Bilder und PDF bis {fileMb} MB · MP4-Videos bis {videoMb} MB.`,
    whatsappLimits: `Das sind die Grenzwerte, die WhatsApp zulässt.`,
    openFile: `{name} öffnen`,
    attachmentFallback: `Anhang`,
    delete: `Löschen`,
    open: `Öffnen`,
    arrivalAttachments: `Anhänge der Anreisehinweise`,
    welcomeAttachments: `Anhänge der Willkommensnachricht`,
    attachHintFull: `Bilder und PDF bis {fileMb} MB · MP4-Videos bis {videoMb} MB. Das sind die Grenzwerte, die WhatsApp zulässt.`,
    noAttachments: `Noch keine Anhänge.`,
    editorSubtitleProperty: `Richten Sie sie je Sprache ein und hängen Sie Dateien an (Bilder, PDF, Video).`,

    // Save
    saveData: `Daten speichern`,
    saving: `Wird gespeichert…`,

    // Lock summary
    locksConfigured: `Schlösser konfiguriert`,
    accessMethodConfigured: `Zugangsart konfiguriert`,
    guestAccess: `Zugang für Gäste`,
    accessDisabledHtml: `Der Versand von Zugangscodes ist <strong>deaktiviert</strong>, er wird nicht in die Anreisehinweise aufgenommen.`,
    noAccessMethod: `Für diese Unterkunft ist noch keine Zugangsart konfiguriert.`,
    locksHint: `Sie wird in der Karte „Schlösser und Zugang“ des Inserats konfiguriert.`,

    // Preview
    online: `online`,
    previewDayArrival: `Anreisetag`,
    previewAfterRegister: `Nach dem Check-in`,
    previewPlaceholder: `Schreiben Sie die Nachricht, um hier die Vorschau zu sehen…`,
    previewIncludesAccess: `Enthält den konfigurierten Zugang`,
    languageLabel: `Sprache {lang}`,
    previewFallbackName: `Ihre Unterkunft`,
    previewFallbackAccommodation: `Ihre Unterkunft`,

    // Lock summaries (computed)
    lockNoteDynamic: `Für jede Buchung wird automatisch ein neuer Schlüssel erzeugt`,
    lockTagBox: `Code des Schlüsseltresors`,
    lockTag: `Code`,
    lockCodePending: `Code noch nicht konfiguriert`,
    lockCodeValue: `{tag}: {code}`,
    lockLabelDefault: `Eingang`,

    // Access preview messages (computed)
    lockMsgDynamic: `🔒🔑 *{label} · {name}*

Ihr Zugangscode lautet: *58117*

Er gilt während Ihres Aufenthalts.`,
    lockMsgBox: `🔑 *{label} · {name}*

Der Schlüsseltresor öffnet sich mit dem Code: *{code}*

Darin finden Sie die Schlüssel zur Unterkunft. Bitte legen Sie sie bei der Abreise wieder zurück.`,
    lockMsgStatic: `🔒🔑 *{label} · {name}*

Der Code des Schlosses lautet: *{code}*

Damit öffnen Sie die Tür der Unterkunft.`,

    // Variable labels (computed)
    varGuestName: `Name des Gastes`,
    varFullName: `Vollständiger Name`,
    varCheckinDate: `Check-in-Datum`,
    varCheckoutDate: `Check-out-Datum`,
    varCheckinTime: `Check-in-Zeit`,
    varCheckoutTime: `Check-out-Zeit`,
    varNights: `Anzahl der Nächte`,
    varGuests: `Anzahl der Gäste`,

    // Lock options (computed)
    lockOptBoxTitle: `Schlüsseltresor`,
    lockOptBoxDesc: `Die Schlüssel liegen in einem Sicherheits-Schlüsseltresor.`,
    lockOptDynamicTitle: `Smartes Schloss`,
    lockOptDynamicDesc: `Für jede Buchung wird automatisch ein neuer Schlüssel erzeugt.`,
    lockOptStaticTitle: `Schloss mit festem Code`,
    lockOptStaticDesc: `Ein Schlüsseltresor oder ein Schloss mit festem Code.`,

    // Default arrival message (computed)
    defaultArrivalMessage: `🏡 *Anreisehinweise*

Hallo *{guest}* 👋

kommen Sie bei Ihrer Ankunft bitte zum Haupteingang der Unterkunft. 🔑

Wenn Sie Hilfe brauchen, schreiben Sie uns einfach hier über WhatsApp 📲

Genießen Sie Ihren Aufenthalt! ✨`,

    // Property context (inherited)
    inheritedChannelsTitle: `Vom Inserat übernommene Kanäle`,
    inheritedListingPrefix: `Diese Unterkunft nutzt die zentrale Willkommensnachricht des Inserats`,
    emailChannel: `E-Mail`,
    otaActive: `OTA aktiv`,
    inheritedNote: `Wenn Sie den OTA-Versand dieser Willkommensnachricht ändern möchten, tun Sie das in den Einstellungen des Inserats.`,
    propertyDeliveryTitle: `Wie wird diese Willkommensnachricht gesendet?`,
    propertyDeliverySubtitle: `Konfigurieren Sie die Versandkanäle für diese Unterkunft.`,
    propertyDeliveryNote: `Diese Kanäle bleiben standardmäßig aktiv. Hier können Sie zusätzlich den OTA-Versand für diese Unterkunft aktivieren.`,
    otaRowTitle: `Willkommensnachrichten über OTAs senden`,
    otaRowText: `Es wird versucht, die Willkommensnachricht dieser Unterkunft über Booking.com und Airbnb mit Channex zu senden, samt der konfigurierten Anhänge.`,
    otaRowHint: `Sie wird zusammen mit der Willkommensnachricht und den Anhängen gespeichert.`,

    // Toasts / validation
    toastLoadError: `Die Nachrichten konnten nicht geladen werden.`,
    toastOtaUpdated: `OTA-Kanal erfolgreich aktualisiert`,
    toastOtaError: `Der OTA-Versand konnte nicht aktualisiert werden`,
    toastSendTimeUpdated: `Sendezeit aktualisiert`,
    toastSendTimeError: `Die Uhrzeit konnte nicht gespeichert werden`,
    toastArrivalEnabled: `Anreisehinweise aktiviert`,
    toastArrivalDisabled: `Anreisehinweise deaktiviert`,
    toastStatusError: `Der Status konnte nicht aktualisiert werden`,
    toastWelcomeEnabled: `Willkommensnachricht aktiviert`,
    toastWelcomeDisabled: `Willkommensnachricht deaktiviert`,
    toastModeUpdated: `Modus erfolgreich aktualisiert`,
    toastModeError: `Der Modus konnte nicht aktualisiert werden`,
    toastAttachUploaded: `Anhang/Anhänge erfolgreich hochgeladen`,
    toastAttachUploadError: `Fehler beim Hochladen der Anhänge`,
    toastAttachDeleted: `Anhang gelöscht`,
    toastAttachDeleteError: `Der Anhang konnte nicht gelöscht werden`,
    toastChangesSaved: `Änderungen gespeichert`,
    toastTranslateEmpty: `Schreiben Sie eine Nachricht in der aktiven Sprache, bevor Sie übersetzen.`,
    toastTranslateSuccess: `{count} Sprachen übersetzt! Prüfen Sie jeden Tab vor dem Speichern.`,
    toastTranslatePartial: `{success} übersetzt, {failed} fehlgeschlagen. Sie können es erneut versuchen.`,
    toastTranslateNone: `Es konnte keine Sprache übersetzt werden. Bitte versuchen Sie es erneut.`,

    // File validation errors (WhatsApp)
    fileErrorVideoFormat: `❌ {name} ist ein {ext}-Video und WhatsApp unterstützt nur MP4. Wandeln Sie es in MP4 um und laden Sie es erneut hoch.`,
    fileErrorTooBig: `❌ {name} hat {mb} MB, das Maximum sind {limMb} MB. `,
    fileErrorTooBigVideo: `WhatsApp erlaubt keine größeren Videos: komprimieren oder kürzen Sie es.`,
    fileErrorTooBigFile: `WhatsApp erlaubt keine größeren Dateien.`,
  },
};
